import React from 'react';
import { NavLink } from 'react-router-dom';
import Tag from './Tag';
import Button from './Button';
import './WorkComponent2.css';

const WorkComponent2 = ({ id, image, title, description, tags }) => {
    return (
        <div className="work2-component">
            <img src={image} alt={title} />
            <div className="content">
                <h2 className='work2-component-title'>{title}</h2>
                <p className='work2-shortdescription'>{description}</p>
                <div className="work2-tags">
                    {tags.map((tag, index) => (
                        <Tag key={index} text={tag} />
                    ))}
                </div>
                <div className='work2-button'>
                    <NavLink to={`/work/${id}`}>
                        <Button text="Learn More" />
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default WorkComponent2;
